export const PROJECT_COLOR_VARS = [
  '--to-chart-running',
  '--to-info-dot',
  '--to-green-dot',
  '--to-neutral-dot',
  '--to-warn-dot',
] as const;

/**
 * Die Farbe haengt an der Stelle des Projekts in der vollstaendigen Projektliste, damit ein
 * Projekt seine Farbe behaelt, wenn der Projektfilter andere ausblendet.
 */
export function projectColorVar(projectId: string, colorOrder: readonly string[], fallbackIndex: number): string {
  const index = colorOrder.indexOf(projectId);
  return PROJECT_COLOR_VARS[(index >= 0 ? index : fallbackIndex) % PROJECT_COLOR_VARS.length];
}
